/* BRWN CLUB — Size Guide Smart Modal v5
   - Tops: usual size + height + chest.
   - Bottoms: usual size + waist + hip + inside leg.
   - Unknown fields are ignored.
   - Women’s bottoms prioritise hip.
   - No auto-jump while typing. Customer clicks CALCULATE SIZE.
*/

(function () {
  'use strict';

  var PRODUCTS = {
    'snow-washed-oversized-cotton-t-shirt-2': {
      name: 'Snow Washed Oversized Cotton T-Shirt',
      type: 'top',
      note: 'Oversized heavyweight cotton tee with a dropped shoulder. Measurements mirror the BRWN oversized tee block. Take your usual size.',
      fitTip: 'Between sizes? Size down for a cleaner fit, size up for a fuller drape.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ['PIT TO PIT (IN)', 'LENGTH (IN)', 'SHOULDER (IN)', 'SLEEVE (IN)'],
      cmCols: ['PIT TO PIT (CM)', 'LENGTH (CM)', 'SHOULDER (CM)', 'SLEEVE (CM)'],
      inchData: [
        [24.02, 25.59, 22.44, 8.86],
        [24.80, 26.38, 23.23, 9.06],
        [25.59, 27.17, 24.02, 9.25],
        [26.38, 27.95, 24.80, 9.45],
        [27.17, 28.74, 25.59, 9.65]
      ],
      cmData: [
        [61.0, 65.0, 57.0, 22.5],
        [63.0, 67.0, 59.0, 23.0],
        [65.0, 69.0, 61.0, 23.5],
        [67.0, 71.0, 63.0, 24.0],
        [69.0, 73.0, 65.0, 24.5]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 46],
      heightAdj: function () { return 0; }
    },

    'boxy-fleece-crewneck-sweatshirt': {
      name: 'Originals Snow Wash Fleece Hoodie',
      type: 'top',
      note: 'Boxy snow-washed pullover hoodie. Measurements mirror the BRWN oversized fleece block. Take your usual size.',
      fitTip: 'For a heavier, slouchier hoodie fit, size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ['PIT TO PIT (IN)', 'LENGTH (IN)', 'SHOULDER (IN)', 'SLEEVE (IN)'],
      cmCols: ['PIT TO PIT (CM)', 'LENGTH (CM)', 'SHOULDER (CM)', 'SLEEVE (CM)'],
      inchData: [
        [26.38, 27.56, 22.44, 24.02],
        [27.17, 28.35, 23.03, 24.41],
        [27.95, 29.13, 23.62, 24.80],
        [28.74, 29.92, 24.21, 25.20],
        [29.53, 30.71, 24.80, 25.59]
      ],
      cmData: [
        [67.0, 70.0, 57.0, 61.0],
        [69.0, 72.0, 58.5, 62.0],
        [71.0, 74.0, 60.0, 63.0],
        [73.0, 76.0, 61.5, 64.0],
        [75.0, 78.0, 63.0, 65.0]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 47],
      heightAdj: function (h) { return h >= 190 ? 1 : 0; }
    },

    'frayed-enzyme-washed-fleece-hoodie-2': {
      name: 'MIST Enzyme Washed Fleece Hoodie',
      type: 'top',
      note: 'Relaxed unisex BRWN fit. Exact garment measurements as supplied. Take your usual size; size up for a heavier oversized look.',
      fitTip: 'Between sizes or want more length? Size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["CHEST (IN)", "LENGTH (IN)", "SHOULDER (IN)", "SLEEVE (IN)"],
      cmCols: ["CHEST (CM)", "LENGTH (CM)", "SHOULDER (CM)", "SLEEVE (CM)"],
      inchData: [
        [27.95, 24.8, 26.18, 23.23],
        [28.74, 25.59, 26.77, 23.62],
        [29.53, 26.38, 27.36, 24.02],
        [30.31, 27.17, 27.95, 24.41],
        [31.1, 27.95, 28.54, 24.8]
      ],
      cmData: [
        [71, 63, 66.5, 59],
        [73, 65, 68, 60],
        [75, 67, 69.5, 61],
        [77, 69, 71, 62],
        [79, 71, 72.5, 63]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 47],
      heightAdj: function (h) { return h >= 190 ? 1 : 0; }
    },

    'frayed-enzyme-washed-fleece-sweatpants-2': {
      name: 'MIST Enzyme Washed Fleece Sweatpants',
      type: 'bottom',
      note: 'Relaxed unisex BRWN fit with elastic/drawstring waist. Exact garment measurements as supplied.',
      fitTip: 'For women, hip is the most accurate guide; for men, waist. Inside leg mainly checks length.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["WAIST (IN)", "HIP (IN)", "LENGTH (IN)"],
      cmCols: ["WAIST (CM)", "HIP (CM)", "LENGTH (CM)"],
      inchData: [
        [12.99, 21.65, 40.94],
        [13.78, 22.44, 41.73],
        [14.57, 23.23, 42.52],
        [15.35, 24.02, 43.31],
        [16.14, 24.8, 44.09]
      ],
      cmData: [
        [33, 55, 104],
        [35, 57, 106],
        [37, 59, 108],
        [39, 61, 110],
        [41, 63, 112]
      ],
      bodyWaistMaxIn: [30, 32, 34, 36, 38],
      bodyHipMaxIn: [38, 41, 43, 45, 47],
      womenHipMaxIn: [39, 42, 44, 46, 48],
      legAdj: function () { return 0; }
    },

    'unisex-solid-color-fleece-straight-leg-pants-8': {
      name: 'BRWN Fleece Straight Leg Pants',
      type: 'bottom',
      note: 'Relaxed unisex BRWN fit with elastic/drawstring waist. Exact garment measurements as supplied.',
      fitTip: 'For women, hip is the most accurate guide; for men, waist. Inside leg mainly checks length.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["WAIST (IN)", "HIP (IN)", "LENGTH (IN)"],
      cmCols: ["WAIST (CM)", "HIP (CM)", "LENGTH (CM)"],
      inchData: [
        [13, 20.9, 40.2],
        [13.8, 21.7, 40.9],
        [14.6, 22.4, 41.7],
        [15.4, 23.2, 42.5],
        [16.1, 24, 43.3]
      ],
      cmData: [
        [33, 53, 102],
        [35, 55, 104],
        [37, 57, 106],
        [39, 59, 108],
        [41, 61, 110]
      ],
      bodyWaistMaxIn: [30, 32, 34, 36, 38],
      bodyHipMaxIn: [38, 41, 43, 45, 47],
      womenHipMaxIn: [39, 42, 44, 46, 48],
      legAdj: function () { return 0; }
    },

    'oversize-fleeced-hoodie-11': {
      name: 'Oversize Fleeced Hoodie (Olive)',
      type: 'top',
      note: 'Relaxed unisex BRWN fit. Exact garment measurements as supplied. Take your usual size; size up for a heavier oversized look.',
      fitTip: 'Between sizes or want more length? Size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["CHEST (IN)", "LENGTH (IN)", "SHOULDER (IN)", "SLEEVE (IN)"],
      cmCols: ["CHEST (CM)", "LENGTH (CM)", "SHOULDER (CM)", "SLEEVE (CM)"],
      inchData: [
        [26, 27.6, 25.6, 21.1],
        [26.8, 28.3, 26.4, 21.5],
        [27.6, 29.1, 27.2, 21.9],
        [28.3, 29.9, 28, 22.2],
        [29.1, 30.7, 28.7, 22.6]
      ],
      cmData: [
        [66, 70, 65, 53.5],
        [68, 72, 67, 54.5],
        [70, 74, 69, 55.5],
        [72, 76, 71, 56.5],
        [74, 78, 73, 57.5]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 47],
      heightAdj: function (h) { return h >= 190 ? 1 : 0; }
    },

    'fleece-drawstring-straight-leg-sweatpants': {
      name: 'Fleece Drawstring Straight-Leg Sweatpants',
      type: 'bottom',
      note: 'Relaxed unisex BRWN fit with elastic/drawstring waist. Exact garment measurements as supplied.',
      fitTip: 'For women, hip is the most accurate guide; for men, waist. Inside leg mainly checks length.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["WAIST (IN)", "HIP (IN)", "LENGTH (IN)"],
      cmCols: ["WAIST (CM)", "HIP (CM)", "LENGTH (CM)"],
      inchData: [
        [13.4, 21.1, 41.7],
        [14.2, 21.9, 42.1],
        [15, 22.6, 42.5],
        [15.7, 23.4, 42.9],
        [16.5, 24.2, 43.3]
      ],
      cmData: [
        [34, 53.5, 106],
        [36, 55.5, 107],
        [38, 57.5, 108],
        [40, 59.5, 109],
        [42, 61.5, 110]
      ],
      bodyWaistMaxIn: [30, 32, 34, 36, 38],
      bodyHipMaxIn: [38, 41, 43, 45, 47],
      womenHipMaxIn: [39, 42, 44, 46, 48],
      legAdj: function () { return 0; }
    },

    'unisex-oversized-t-shirt': {
      name: 'Originals Oversized T-Shirt - Espresso',
      type: 'top',
      note: 'Relaxed unisex BRWN fit. Exact garment measurements as supplied. Take your usual size; size up for a heavier oversized look.',
      fitTip: 'Between sizes or want more length? Size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["CHEST (IN)", "LENGTH (IN)"],
      cmCols: ["CHEST (CM)", "LENGTH (CM)"],
      inchData: [
        [51.96, 23.23],
        [53.54, 24.02],
        [55.12, 24.8],
        [56.7, 25.59],
        [58.26, 26.38]
      ],
      cmData: [
        [132, 59],
        [136, 61],
        [140, 63],
        [144, 65],
        [148, 67]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 46],
      heightAdj: function () { return 0; }
    },

    'boxy-fleece-crewneck-sweatshirt-2': {
      name: 'Originals Boxy Fleece Crewneck Sweatshirt',
      type: 'top',
      note: 'Relaxed unisex BRWN fit. Exact garment measurements as supplied. Take your usual size; size up for a heavier oversized look.',
      fitTip: 'Between sizes or want more length? Size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["CHEST (IN)", "LENGTH (IN)"],
      cmCols: ["CHEST (CM)", "LENGTH (CM)"],
      inchData: [
        [41.74, 27.95],
        [44.1, 28.74],
        [46.46, 29.53],
        [48.82, 30.31],
        [51.18, 31.1]
      ],
      cmData: [
        [106, 71],
        [112, 73],
        [118, 75],
        [124, 77],
        [130, 79]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 47],
      heightAdj: function (h) { return h >= 190 ? 1 : 0; }
    },

    'mesh-lined-quick-dry-athletic-leg-pants-2': {
      name: 'Mesh-Lined Quick-Dry Athletic Leg Pants',
      type: 'bottom',
      note: 'Relaxed unisex BRWN fit with elastic/drawstring waist. Exact garment measurements as supplied.',
      fitTip: 'For women, hip is the most accurate guide; for men, waist. Inside leg mainly checks length.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["WAIST (IN)", "HIP (IN)", "LENGTH (IN)"],
      cmCols: ["WAIST (CM)", "HIP (CM)", "LENGTH (CM)"],
      inchData: [
        [12.6, 22.44, 38.58],
        [13.39, 23.23, 39.37],
        [14.17, 24.02, 40.16],
        [14.96, 24.8, 40.94],
        [15.75, 25.59, 41.73]
      ],
      cmData: [
        [32, 57, 98],
        [34, 59, 100],
        [36, 61, 102],
        [38, 63, 104],
        [40, 65, 106]
      ],
      bodyWaistMaxIn: [30, 32, 34, 36, 38],
      bodyHipMaxIn: [38, 41, 43, 45, 47],
      womenHipMaxIn: [39, 42, 44, 46, 48],
      legAdj: function () { return 0; }
    },

    'fleece-zip-up-boxy-hoodie-1': {
      name: 'Fleece Zip-Up Boxy Hoodie',
      type: 'top',
      note: 'Relaxed unisex BRWN fit. Exact garment measurements as supplied. Take your usual size; size up for a heavier oversized look.',
      fitTip: 'Between sizes or want more length? Size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["CHEST (IN)", "LENGTH (IN)", "SHOULDER (IN)", "SLEEVE (IN)"],
      cmCols: ["CHEST (CM)", "LENGTH (CM)", "SHOULDER (CM)", "SLEEVE (CM)"],
      inchData: [
        [24.41, 23.62, 24.41, 22.44],
        [25.2, 24.41, 25.2, 22.83],
        [25.98, 25.2, 25.98, 23.23],
        [26.77, 25.98, 26.77, 23.62],
        [27.56, 26.77, 27.56, 24.02]
      ],
      cmData: [
        [62, 60, 62, 57],
        [64, 62, 64, 58],
        [66, 64, 66, 59],
        [68, 66, 68, 60],
        [70, 68, 70, 61]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 47],
      heightAdj: function (h) { return h >= 190 ? 1 : 0; }
    },

    'fleece-drawstring-straight-leg-sweatpants-1': {
      name: 'Fleece Drawstring Straight-Leg Sweatpants',
      type: 'bottom',
      note: 'Relaxed unisex BRWN fit with elastic/drawstring waist. Exact garment measurements as supplied.',
      fitTip: 'For women, hip is the most accurate guide; for men, waist. Inside leg mainly checks length.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["WAIST (IN)", "HIP (IN)", "LENGTH (IN)"],
      cmCols: ["WAIST (CM)", "HIP (CM)", "LENGTH (CM)"],
      inchData: [
        [13.39, 21.06, 41.73],
        [14.17, 21.85, 42.13],
        [14.96, 22.64, 42.52],
        [15.75, 23.43, 42.91],
        [16.54, 24.21, 43.31]
      ],
      cmData: [
        [34, 53.5, 106],
        [36, 55.5, 107],
        [38, 57.5, 108],
        [40, 59.5, 109],
        [42, 61.5, 110]
      ],
      bodyWaistMaxIn: [30, 32, 34, 36, 38],
      bodyHipMaxIn: [38, 41, 43, 45, 47],
      womenHipMaxIn: [39, 42, 44, 46, 48],
      legAdj: function () { return 0; }
    },

    'oversize-fleeced-hoodie-12': {
      name: 'Oversize Fleeced Hoodie',
      type: 'top',
      note: 'Relaxed unisex BRWN fit. Exact garment measurements as supplied. Take your usual size; size up for a heavier oversized look.',
      fitTip: 'Between sizes or want more length? Size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["CHEST (IN)", "LENGTH (IN)", "SHOULDER (IN)", "SLEEVE (IN)"],
      cmCols: ["CHEST (CM)", "LENGTH (CM)", "SHOULDER (CM)", "SLEEVE (CM)"],
      inchData: [
        [25.98, 27.56, 25.59, 21.06],
        [26.77, 28.35, 26.38, 21.46],
        [27.56, 29.13, 27.17, 21.85],
        [28.35, 29.92, 27.95, 22.24],
        [29.13, 30.71, 28.74, 22.64]
      ],
      cmData: [
        [66, 70, 65, 53.5],
        [68, 72, 67, 54.5],
        [70, 74, 69, 55.5],
        [72, 76, 71, 56.5],
        [74, 78, 73, 57.5]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 47],
      heightAdj: function (h) { return h >= 190 ? 1 : 0; }
    },

    'solid-color-straight-leg-sweatpants-5': {
      name: 'Solid Color Straight-Leg Sweatpants',
      type: 'bottom',
      note: 'Relaxed unisex BRWN fit with elastic/drawstring waist. Exact garment measurements as supplied.',
      fitTip: 'For women, hip is the most accurate guide; for men, waist. Inside leg mainly checks length.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["WAIST (IN)", "HIP (IN)", "LENGTH (IN)"],
      cmCols: ["WAIST (CM)", "HIP (CM)", "LENGTH (CM)"],
      inchData: [
        [13.39, 20.87, 40.55],
        [14.17, 21.65, 41.34],
        [14.96, 22.44, 42.13],
        [15.75, 23.23, 42.91],
        [16.54, 24.02, 43.7]
      ],
      cmData: [
        [34, 53, 103],
        [36, 55, 105],
        [38, 57, 107],
        [40, 59, 109],
        [42, 61, 111]
      ],
      bodyWaistMaxIn: [30, 32, 34, 36, 38],
      bodyHipMaxIn: [38, 41, 43, 45, 47],
      womenHipMaxIn: [39, 42, 44, 46, 48],
      legAdj: function () { return 0; }
    },

    'essential-heavyweight-hoodie-4': {
      name: 'Essential Heavyweight Hoodie',
      type: 'top',
      note: 'Relaxed unisex BRWN fit. Exact garment measurements as supplied. Take your usual size; size up for a heavier oversized look.',
      fitTip: 'Between sizes or want more length? Size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ["CHEST (IN)", "LENGTH (IN)", "SHOULDER (IN)", "SLEEVE (IN)"],
      cmCols: ["CHEST (CM)", "LENGTH (CM)", "SHOULDER (CM)", "SLEEVE (CM)"],
      inchData: [
        [25.59, 27.56, 25.2, 20.87],
        [26.38, 28.35, 25.98, 21.26],
        [27.17, 29.13, 26.77, 21.65],
        [27.95, 29.92, 27.56, 22.05],
        [28.74, 30.71, 28.35, 22.44]
      ],
      cmData: [
        [65, 70, 64, 53],
        [67, 72, 66, 54],
        [69, 74, 68, 55],
        [71, 76, 70, 56],
        [73, 78, 72, 57]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 47],
      heightAdj: function (h) { return h >= 190 ? 1 : 0; }
    },

    'boxy-oversized-t-shirt': {
      name: 'Boxy Oversized T-Shirt',
      type: 'top',
      note: 'Oversized boxy fit with a deliberately shorter body. At 5\'9, Medium gives the cropped BRWN look; taller customers should usually size up for length.',
      fitTip: 'Use your usual size for the cropped oversized look. Size up if you are tall, long-torsoed, or want more body length.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ['PIT TO PIT (IN)', 'LENGTH (IN)', 'SHOULDER (IN)', 'SLEEVE (IN)'],
      cmCols: ['PIT TO PIT (CM)', 'LENGTH (CM)', 'SHOULDER (CM)', 'SLEEVE (CM)'],
      inchData: [
        [24.02, 25.59, 22.44, 8.86],
        [24.80, 26.38, 23.23, 9.06],
        [25.59, 27.17, 24.02, 9.25],
        [26.38, 27.95, 24.80, 9.45],
        [27.17, 28.74, 25.59, 9.65]
      ],
      cmData: [
        [61.0, 65.0, 57.0, 22.5],
        [63.0, 67.0, 59.0, 23.0],
        [65.0, 69.0, 61.0, 23.5],
        [67.0, 71.0, 63.0, 24.0],
        [69.0, 73.0, 65.0, 24.5]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 46],
      heightAdj: function (h) {
        if (h >= 188) return 2;
        if (h >= 180) return 1;
        if (h < 164) return -1;
        return 0;
      }
    },

    'mineral-wash-waffle-knit-t-shirt': {
      name: 'Mineral Wash Waffle Knit T-Shirt',
      type: 'top',
      note: 'Oversized waffle knit tee with a longer body. Take your usual size.',
      fitTip: 'If you are between sizes, size up for a looser summer fit.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ['PIT TO PIT (IN)', 'LENGTH (IN)', 'SHOULDER (IN)', 'SLEEVE (IN)'],
      cmCols: ['PIT TO PIT (CM)', 'LENGTH (CM)', 'SHOULDER (CM)', 'SLEEVE (CM)'],
      inchData: [
        [22.44, 27.56, 22.05, 8.27],
        [23.23, 28.35, 22.64, 8.46],
        [24.02, 29.13, 23.23, 8.66],
        [24.80, 29.92, 23.82, 8.86],
        [25.59, 30.71, 24.41, 9.06]
      ],
      cmData: [
        [57.0, 70.0, 56.0, 21.0],
        [59.0, 72.0, 57.5, 21.5],
        [61.0, 74.0, 59.0, 22.0],
        [63.0, 76.0, 60.5, 22.5],
        [65.0, 78.0, 62.0, 23.0]
      ],
      bodyChestMaxIn: [36, 38, 40, 42, 44],
      heightAdj: function () {
        return 0;
      }
    },

    'snow-wash-fleece-oversize-hoodie': {
      name: 'Snow Wash Fleece Oversize Hoodie',
      type: 'top',
      note: 'Oversized fleece hoodie with a relaxed streetwear fit. Take your usual size.',
      fitTip: 'For a heavier, slouchier hoodie fit, size up.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ['PIT TO PIT (IN)', 'LENGTH (IN)', 'SHOULDER (IN)', 'SLEEVE (IN)'],
      cmCols: ['PIT TO PIT (CM)', 'LENGTH (CM)', 'SHOULDER (CM)', 'SLEEVE (CM)'],
      inchData: [
        [26.38, 27.56, 22.44, 24.02],
        [27.17, 28.35, 23.03, 24.41],
        [27.95, 29.13, 23.62, 24.80],
        [28.74, 29.92, 24.21, 25.20],
        [29.53, 30.71, 24.80, 25.59]
      ],
      cmData: [
        [67.0, 70.0, 57.0, 61.0],
        [69.0, 72.0, 58.5, 62.0],
        [71.0, 74.0, 60.0, 63.0],
        [73.0, 76.0, 61.5, 64.0],
        [75.0, 78.0, 63.0, 65.0]
      ],
      bodyChestMaxIn: [38, 40, 42, 44, 47],
      heightAdj: function (h) {
        return h >= 190 ? 1 : 0;
      }
    },

    'zip-through-boxy-fleece-hoodie': {
      name: 'Zip-Through Boxy Fleece Hoodie',
      type: 'top',
      note: 'Boxy zip hoodie with a shorter body. If you are tall, size up for extra length.',
      fitTip: 'This is slightly cropped compared to a standard hoodie.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ['PIT TO PIT (IN)', 'LENGTH (IN)', 'SHOULDER (IN)', 'SLEEVE (IN)'],
      cmCols: ['PIT TO PIT (CM)', 'LENGTH (CM)', 'SHOULDER (CM)', 'SLEEVE (CM)'],
      inchData: [
        [24.41, 24.80, 22.44, 22.44],
        [25.20, 25.39, 23.23, 22.83],
        [25.98, 25.98, 24.02, 23.23],
        [26.77, 26.57, 24.80, 23.62],
        [27.56, 27.17, 25.59, 24.02]
      ],
      cmData: [
        [62.0, 63.0, 57.0, 57.0],
        [64.0, 64.5, 59.0, 58.0],
        [66.0, 66.0, 61.0, 59.0],
        [68.0, 67.5, 63.0, 60.0],
        [70.0, 69.0, 65.0, 61.0]
      ],
      bodyChestMaxIn: [37, 39, 41, 43, 45],
      heightAdj: function (h) {
        if (h >= 188) return 2;
        if (h >= 178) return 1;
        return 0;
      }
    },

    'fleeced-jogger-sweatpants': {
      name: 'Fleeced Jogger Sweatpants',
      type: 'bottom',
      note: 'Relaxed fleeced jogger with elastic waist. Use your normal UK trouser waist and inside leg; a 32 inside leg should not automatically push you into Large.',
      fitTip: 'For women, hip measurement is the most important. For men, waist is the main guide. Inside leg mainly checks length, not overall size.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ['WAIST RELAXED (IN)', 'HIP WIDTH (IN)', 'LENGTH (IN)'],
      cmCols: ['WAIST RELAXED (CM)', 'HIP WIDTH (CM)', 'LENGTH (CM)'],
      inchData: [
        [13.39, 22.05, 37.40],
        [14.17, 22.83, 38.19],
        [14.96, 23.62, 38.98],
        [15.75, 24.41, 39.76],
        [16.54, 25.20, 40.55]
      ],
      cmData: [
        [34.0, 56.0, 95.0],
        [36.0, 58.0, 97.0],
        [38.0, 60.0, 99.0],
        [40.0, 62.0, 101.0],
        [42.0, 64.0, 103.0]
      ],
      bodyWaistMaxIn: [30, 32, 34, 36, 38],
      bodyHipMaxIn: [38, 41, 43, 45, 47],
      womenHipMaxIn: [39, 42, 44, 46, 48],
      baseAdj: 0,
      legAdj: function (insideLegIn) {
        if (insideLegIn >= 35) return 1;
        return 0;
      }
    },

    'mineral-wash-waffle-knit-shorts': {
      name: 'Mineral Wash Waffle Knit Shorts',
      type: 'bottom',
      note: 'Relaxed summer short with elastic waist. Take your usual size.',
      fitTip: 'For women, use hip measurement for the most accurate result. For men, waist is usually enough.',
      sizes: ['S', 'M', 'L', 'XL', '2XL'],
      inchCols: ['WAIST RELAXED (IN)', 'HIP WIDTH (IN)', 'LENGTH (IN)'],
      cmCols: ['WAIST RELAXED (CM)', 'HIP WIDTH (CM)', 'LENGTH (CM)'],
      inchData: [
        [12.99, 21.46, 20.08],
        [13.78, 22.24, 20.47],
        [14.57, 23.03, 20.87],
        [15.35, 23.82, 21.26],
        [16.14, 24.61, 21.65]
      ],
      cmData: [
        [33.0, 54.5, 51.0],
        [35.0, 56.5, 52.0],
        [37.0, 58.5, 53.0],
        [39.0, 60.5, 54.0],
        [41.0, 62.5, 55.0]
      ],
      bodyWaistMaxIn: [30, 32, 34, 36, 38],
      bodyHipMaxIn: [37, 40, 42, 44, 46],
      womenHipMaxIn: [39, 42, 44, 46, 48],
      legAdj: function () {
        return 0;
      }
    }
  };

  Object.assign(PRODUCTS, {"fleece-zip-up-boxy-hoodie-2": {"name": "Signature Boxy Zip-Up Hoodie", "type": "top", "union": true, "sizes": ["S", "M", "L", "XL", "2XL"], "inchCols": ["LENGTH (IN)", "SHOULDER (IN)", "CHEST (IN)", "SLEEVE LENGTH (IN)"], "cmCols": ["LENGTH (CM)", "SHOULDER (CM)", "CHEST (CM)", "SLEEVE LENGTH (CM)"], "inchData": [[23.62, 24.41, 24.41, 22.44], [24.41, 25.2, 25.2, 22.83], [25.2, 25.98, 25.98, 23.23], [25.98, 26.77, 26.77, 23.62], [26.77, 27.56, 27.56, 24.02]], "cmData": [[60.0, 62.0, 62.0, 57.0], [62.0, 64.0, 64.0, 58.0], [64.0, 66.0, 66.0, 59.0], [66.0, 68.0, 68.0, 60.0], [68.0, 70.0, 70.0, 61.0]], "note": "Measurements are from this product’s supplier size chart. Chest-based estimates allow 4 inches of room around the body.", "fitTip": "Compare with a garment you like the fit of.", "tableNote": "Garment measurements, taken flat. Chest, waist and hip are widths, not body circumferences. Length is the full garment length.", "bodyChestMaxIn": [44.82, 46.4, 47.96, 49.54, 51.12]}, "fleece-drawstring-straight-leg-sweatpants-2": {"name": "Studio Straight-Leg Sweatpants", "type": "bottom", "union": true, "sizes": ["S", "M", "L", "XL", "2XL"], "inchCols": ["LENGTH (IN)", "WAIST (IN)", "HIP (IN)"], "cmCols": ["LENGTH (CM)", "WAIST (CM)", "HIP (CM)"], "inchData": [[41.73, 13.39, 21.06], [42.13, 14.17, 21.85], [42.52, 14.96, 22.64], [42.91, 15.75, 23.43], [43.31, 16.54, 24.21]], "cmData": [[106.0, 34.0, 53.5], [107.0, 36.0, 55.5], [108.0, 38.0, 57.5], [109.0, 40.0, 59.5], [110.0, 42.0, 61.5]], "note": "Measurements are from this product’s supplier size chart. Fit estimates use the relaxed waist and allow 2 inches of room at the hip; waistband stretch is not specified.", "fitTip": "Compare with a garment you like the fit of.", "tableNote": "Garment measurements, taken flat. Chest, waist and hip are widths, not body circumferences. Length is the full garment length.", "bodyWaistMaxIn": [26.78, 28.34, 29.92, 31.5, 33.08], "bodyHipMaxIn": [40.12, 41.7, 43.28, 44.86, 46.42]}, "boxy-fleece-crewneck-sweatshirt-3": {"name": "Insignia Boxy Crewneck", "type": "top", "union": true, "sizes": ["S", "M", "L", "XL", "2XL"], "inchCols": ["LENGTH (IN)", "CHEST (IN)", "SHOULDER (IN)", "SLEEVE LENGTH (IN)"], "cmCols": ["LENGTH (CM)", "CHEST (CM)", "SHOULDER (CM)", "SLEEVE LENGTH (CM)"], "inchData": [[23.23, 25.98, 23.62, 21.65], [24.02, 26.77, 24.41, 22.05], [24.8, 27.56, 25.2, 22.44], [25.59, 28.35, 25.98, 22.83], [26.38, 29.13, 26.77, 23.23]], "cmData": [[59.0, 66.0, 60.0, 55.0], [61.0, 68.0, 62.0, 56.0], [63.0, 70.0, 64.0, 57.0], [65.0, 72.0, 66.0, 58.0], [67.0, 74.0, 68.0, 59.0]], "note": "Measurements are from this product’s supplier size chart. Chest-based estimates allow 4 inches of room around the body.", "fitTip": "Compare with a garment you like the fit of.", "tableNote": "Garment measurements, taken flat. Chest, waist and hip are widths, not body circumferences. Length is the full garment length.", "bodyChestMaxIn": [47.96, 49.54, 51.12, 52.7, 54.26]}, "essential-heavyweight-cotton-hoodie-1": {"name": "Union Heavyweight Hoodie", "type": "top", "union": true, "sizes": ["2XS", "XS", "S", "M", "L", "XL"], "inchCols": ["LENGTH (IN)", "SHOULDER (IN)", "CHEST (IN)", "SLEEVE LENGTH (IN)"], "cmCols": ["LENGTH (CM)", "SHOULDER (CM)", "CHEST (CM)", "SLEEVE LENGTH (CM)"], "inchData": [[26.18, 23.43, 22.05, 21.46], [26.97, 24.02, 22.83, 21.85], [27.76, 24.61, 23.62, 22.24], [28.54, 25.2, 24.41, 22.64], [29.33, 25.79, 25.2, 23.03], [29.72, 26.38, 25.98, 23.43]], "cmData": [[66.5, 59.5, 56.0, 54.5], [68.5, 61.0, 58.0, 55.5], [70.5, 62.5, 60.0, 56.5], [72.5, 64.0, 62.0, 57.5], [74.5, 65.5, 64.0, 58.5], [75.5, 67.0, 66.0, 59.5]], "note": "Measurements are from this product’s supplier size chart. Chest-based estimates allow 4 inches of room around the body.", "fitTip": "Compare with a garment you like the fit of.", "tableNote": "Garment measurements, taken flat. Chest, waist and hip are widths, not body circumferences. Length is the full garment length.", "bodyChestMaxIn": [40.1, 41.66, 43.24, 44.82, 46.4, 47.96]}, "essential-heavyweight-cotton-sweatpants-1": {"name": "Union Heavyweight Joggers", "type": "bottom", "union": true, "sizes": ["2XS", "XS", "S", "M", "L"], "inchCols": ["LENGTH (IN)", "WAIST (IN)", "HIP (IN)"], "cmCols": ["LENGTH (CM)", "WAIST (CM)", "HIP (CM)"], "inchData": [[38.58, 14.37, 20.47], [39.37, 14.96, 21.26], [40.16, 15.55, 22.05], [40.94, 16.14, 22.83], [41.73, 16.73, 23.62]], "cmData": [[98.0, 36.5, 52.0], [100.0, 38.0, 54.0], [102.0, 39.5, 56.0], [104.0, 41.0, 58.0], [106.0, 42.5, 60.0]], "note": "Measurements are from this product’s supplier size chart. Fit estimates use the relaxed waist and allow 2 inches of room at the hip; waistband stretch is not specified.", "fitTip": "Compare with a garment you like the fit of.", "tableNote": "Garment measurements, taken flat. Chest, waist and hip are widths, not body circumferences. Length is the full garment length.", "bodyWaistMaxIn": [28.74, 29.92, 31.1, 32.28, 33.46], "bodyHipMaxIn": [38.94, 40.52, 42.1, 43.66, 45.24]}, "unisex-oversized-t-shirt-1": {"name": "Script Oversized T-Shirt", "type": "top", "union": true, "sizes": ["S", "M", "L", "XL", "2XL"], "inchCols": ["LENGTH (IN)", "SHOULDER (IN)", "CHEST (IN)", "SLEEVE LENGTH (IN)"], "cmCols": ["LENGTH (CM)", "SHOULDER (CM)", "CHEST (CM)", "SLEEVE LENGTH (CM)"], "inchData": [[27.95, 19.69, 20.87, 8.66], [28.74, 20.87, 22.05, 8.86], [29.53, 22.05, 23.23, 9.06], [30.31, 23.23, 24.41, 9.25], [31.1, 24.41, 25.59, 9.45]], "cmData": [[71.0, 50.0, 53.0, 22.0], [73.0, 53.0, 56.0, 22.5], [75.0, 56.0, 59.0, 23.0], [77.0, 59.0, 62.0, 23.5], [79.0, 62.0, 65.0, 24.0]], "note": "Measurements are from this product’s supplier size chart. Chest-based estimates allow 4 inches of room around the body.", "fitTip": "Compare with a garment you like the fit of.", "tableNote": "Garment measurements, taken flat. Chest, waist and hip are widths, not body circumferences. Length is the full garment length.", "bodyChestMaxIn": [37.74, 40.1, 42.46, 44.82, 47.18]}, "unisex-quarter-zip-pullover-sweatshirt": {"name": "Script Quarter-Zip Sweatshirt", "type": "top", "union": true, "sizes": ["S", "M", "L", "XL", "2XL"], "inchCols": ["LENGTH (IN)", "CHEST (IN)", "SLEEVE LENGTH (IN)"], "cmCols": ["LENGTH (CM)", "CHEST (CM)", "SLEEVE LENGTH (CM)"], "inchData": [[25.2, 21.26, 28.74], [25.98, 22.05, 29.13], [26.77, 22.83, 29.53], [27.56, 23.62, 29.92], [28.35, 24.41, 30.31]], "cmData": [[64.0, 54.0, 73.0], [66.0, 56.0, 74.0], [68.0, 58.0, 75.0], [70.0, 60.0, 76.0], [72.0, 62.0, 77.0]], "note": "Measurements are from this product’s supplier size chart. Chest-based estimates allow 4 inches of room around the body.", "fitTip": "Compare with a garment you like the fit of.", "tableNote": "Garment measurements, taken flat. Chest, waist and hip are widths, not body circumferences. Length is the full garment length.", "bodyChestMaxIn": [38.52, 40.1, 41.66, 43.24, 44.82]}});

  // Preserve the established fit rules where the supplier garment block is unchanged.
  var unionStraight = PRODUCTS['fleece-drawstring-straight-leg-sweatpants-2'];
  var originalStraight = PRODUCTS['fleece-drawstring-straight-leg-sweatpants-1'];
  unionStraight.bodyWaistMaxIn = originalStraight.bodyWaistMaxIn.slice();
  unionStraight.bodyHipMaxIn = originalStraight.bodyHipMaxIn.slice();
  unionStraight.womenHipMaxIn = originalStraight.womenHipMaxIn.slice();
  unionStraight.note = 'This product uses the existing BRWN straight-leg fit guide, with the exact supplier garment measurements shown below.';

  var DEFAULT_HANDLE = 'boxy-oversized-t-shirt';

  var USUAL_TO_PRODUCT_INDEX = {
    XS: 0,
    S: 0,
    M: 1,
    L: 2,
    XL: 3,
    XXL: 4,
    '2XL': 4
  };

  var state = {
    step: 1,
    gender: null,
    usualSize: null,
    heightCm: null,
    heightUnit: 'ftin',
    bodyUnit: 'in',
    chestIn: null,
    waistIn: null,
    hipIn: null,
    legIn: null,
    handle: null,
    product: null
  };

  function init() {
    var modal = document.getElementById('bc-size-guide');
    if (!modal) return;

    detectProduct();
    var cartButton = document.getElementById('bc-sg-add');
    if (cartButton) cartButton.addEventListener('click', addRecommendedToCart);
    setDefaultUnitButtons();
    updateFieldVisibility();
    updateCalculateButton();

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-bc-open-size-guide]')) {
        event.preventDefault();
        openModal();
      }
    });

    var closeBtn = document.getElementById('bc-sg-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    var backdrop = modal.querySelector('.bc-sg__backdrop');
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('bc-sg--open')) {
        closeModal();
      }
    });

    modal.querySelectorAll('[data-sg-gender]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.gender = btn.dataset.sgGender;
        activateBtns(modal.querySelectorAll('[data-sg-gender]'), btn);
        goToStep(2);
        updateFieldVisibility();
        updateCalculateButton();
      });
    });

    modal.querySelectorAll('[data-sg-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.usualSize = normaliseSize(btn.dataset.sgSize);
        activateBtns(modal.querySelectorAll('[data-sg-size]'), btn);
        clearError('bc-sg-general-error');
        updateCalculateButton();
      });
    });

    var heightInput = document.getElementById('bc-sg-height');
    if (heightInput) {
      heightInput.addEventListener('input', function () {
        parseHeightField(this.value);
        updateCalculateButton();
      });
      heightInput.addEventListener('keydown', handleEnterCalculate);
    }

    modal.querySelectorAll('[data-height-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.heightUnit = btn.dataset.heightUnit;

        modal.querySelectorAll('[data-height-unit]').forEach(function (b) {
          b.classList.toggle('bc-sg__unit-btn--active', b === btn);
        });

        var input = document.getElementById('bc-sg-height');
        if (input) {
          input.value = '';
          input.placeholder = state.heightUnit === 'cm' ? 'e.g. 175' : 'e.g. 5ft9';
          input.setAttribute('inputmode', state.heightUnit === 'cm' ? 'decimal' : 'text');
        }

        state.heightCm = null;
        clearError('bc-sg-height-error');
        updateCalculateButton();
      });
    });

    modal.querySelectorAll('[data-body-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.bodyUnit = btn.dataset.bodyUnit;

        modal.querySelectorAll('[data-body-unit]').forEach(function (b) {
          b.classList.toggle('bc-sg__btn--selected', b === btn);
        });

        clearBodyFields();
        updateBodyPlaceholders();
        updateCalculateButton();
      });
    });

    ['chest', 'waist', 'hip', 'leg'].forEach(function (field) {
      var input = document.getElementById('bc-sg-' + field);
      if (!input) return;

      input.addEventListener('input', function () {
        parseBodyField(field, this.value);
        updateCalculateButton();
      });

      input.addEventListener('keydown', handleEnterCalculate);
    });

    var getBtn = document.getElementById('bc-sg-get-size');
    if (getBtn) {
      getBtn.addEventListener('click', function () {
        validateCurrentFields();

        if (!canCalculate()) {
          updateCalculateButton();
          return;
        }

        showResult();
      });
    }

    var backBtn = document.getElementById('bc-sg-back');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        goToStep(state.step > 2 ? 2 : 1);
      });
    }

    var againBtn = document.getElementById('bc-sg-start-again');
    if (againBtn) againBtn.addEventListener('click', resetAll);
  }

  function detectProduct() {
    var parts = window.location.pathname.split('/');
    var productIndex = parts.indexOf('products');

    if (productIndex !== -1 && parts[productIndex + 1]) {
      state.handle = parts[productIndex + 1];
    }

    var payload = document.getElementById('bc-sg-product-data');
    if (payload) { try { state.handle = JSON.parse(payload.textContent).handle || state.handle; } catch (error) {} }
    state.product = PRODUCTS[state.handle] || null;
  }

  function isFemale() {
    return state.gender === 'female';
  }

  function isBottom(product) {
    return product && product.type === 'bottom';
  }

  function isTop(product) {
    return product && product.type === 'top';
  }

  function isWaffleShorts(product) {
    return product && product.name === 'Mineral Wash Waffle Knit Shorts';
  }

  function setDefaultUnitButtons() {
    document.querySelectorAll('[data-height-unit]').forEach(function (btn) {
      btn.classList.toggle('bc-sg__unit-btn--active', btn.dataset.heightUnit === state.heightUnit);
    });

    document.querySelectorAll('[data-body-unit]').forEach(function (btn) {
      btn.classList.toggle('bc-sg__btn--selected', btn.dataset.bodyUnit === state.bodyUnit);
    });

    updateBodyPlaceholders();
  }

  function updateFieldVisibility() {
    var product = state.product || PRODUCTS[DEFAULT_HANDLE];
    var topFields = document.getElementById('bc-sg-top-fields');
    var bottomFields = document.getElementById('bc-sg-bottom-fields');

    if (topFields) {
      topFields.classList.toggle('bc-sg__step--hidden', !isTop(product));
    }

    if (bottomFields) {
      bottomFields.classList.toggle('bc-sg__step--hidden', !isBottom(product));
    }
  }

  function updateBodyPlaceholders() {
    var unit = state.bodyUnit;

    setPlaceholder('bc-sg-chest', unit === 'cm' ? 'e.g. 101' : 'e.g. 40');
    setPlaceholder('bc-sg-waist', unit === 'cm' ? 'e.g. 86' : 'e.g. 34');
    setPlaceholder('bc-sg-hip', unit === 'cm' ? 'e.g. 102' : 'e.g. 40');
    setPlaceholder('bc-sg-leg', unit === 'cm' ? 'e.g. 81' : 'e.g. 32');
  }

  function setPlaceholder(id, value) {
    var input = document.getElementById(id);
    if (input) input.placeholder = value;
  }

  function normaliseSize(size) {
    if (!size) return null;
    size = String(size).toUpperCase().trim();
    if (size === '2XL') return 'XXL';
    return size;
  }

  function parseHeightField(value) {
    var error = document.getElementById('bc-sg-height-error');

    if (!value || !value.trim()) {
      state.heightCm = null;
      if (error) error.textContent = '';
      return;
    }

    var cm = parseHeightToCm(value.trim(), state.heightUnit);

    if (cm === null) {
      if (error) error.textContent = 'Enter your height, for example 5ft9, 5\'9 or 175.';
      state.heightCm = null;
      return;
    }

    if (cm < 120 || cm > 230) {
      if (error) error.textContent = 'That height looks unusual. Please check it.';
      state.heightCm = null;
      return;
    }

    state.heightCm = cm;
    if (error) error.textContent = '';
  }

  function parseHeightToCm(value, unit) {
    var raw = String(value || '').toLowerCase().trim();
    raw = raw
      .replace(/[“”]/g, 'in')
      .replace(/[‘’]/g, "'")
      .replace(/feet|foot/g, 'ft')
      .replace(/inches|inch/g, 'in');

    if (unit === 'cm') {
      var cm = parseFloat(raw.replace(/[^0-9.]/g, ''));
      return !isNaN(cm) ? cm : null;
    }

    /* Be forgiving for UK shorthand: 5ft9, 5 ft 9, 5'9, 5.9, 5 9. */
    var decimalShorthand = raw.match(/^(\d)\s*[.]\s*(\d{1,2})$/);
    if (decimalShorthand) {
      var decFeet = parseInt(decimalShorthand[1], 10);
      var decInches = parseInt(decimalShorthand[2], 10);
      if (decFeet > 0 && decFeet <= 8 && decInches >= 0 && decInches < 12) {
        return decFeet * 30.48 + decInches * 2.54;
      }
    }

    var clean = raw
      .replace(/\s+/g, ' ')
      .replace(/ft/g, "'")
      .replace(/in/g, '')
      .replace(/"/g, '')
      .trim();

    var match = clean.match(/^(\d+)\s*(?:['’])?\s*(\d{0,2})$/);

    if (match) {
      var feet = parseInt(match[1], 10);
      var inches = match[2] ? parseInt(match[2], 10) : 0;

      if (feet > 0 && feet <= 8 && inches >= 0 && inches < 12) {
        return feet * 30.48 + inches * 2.54;
      }
    }

    var plain = parseFloat(raw.replace(/[^0-9.]/g, ''));

    /* If someone leaves FT selected but types a cm value, still accept it. */
    if (!isNaN(plain) && plain >= 100 && plain <= 230) {
      return plain;
    }

    if (!isNaN(plain) && plain > 3 && plain <= 8) {
      return plain * 30.48;
    }

    return null;
  }

  function parseBodyField(field, value) {
    var error = document.getElementById('bc-sg-' + field + '-error');
    var stateKey = field + 'In';

    if (!value || !value.trim()) {
      state[stateKey] = null;
      if (error) error.textContent = '';
      return;
    }

    var number = parseFloat(value.replace(/[^0-9.]/g, ''));

    if (isNaN(number) || number <= 0) {
      if (error) error.textContent = 'Enter a number.';
      state[stateKey] = null;
      return;
    }

    var inches = state.bodyUnit === 'cm' ? number / 2.54 : number;
    var range = getRangeForField(field);

    if (inches < range.min || inches > range.max) {
      if (error) error.textContent = 'That measurement looks unusual. Please check it.';
      state[stateKey] = null;
      return;
    }

    state[stateKey] = inches;
    if (error) error.textContent = '';
  }

  function getRangeForField(field) {
    if (field === 'chest') return { min: 24, max: 70 };
    if (field === 'waist') return { min: 20, max: 70 };
    if (field === 'hip') return { min: 25, max: 75 };
    if (field === 'leg') return { min: 18, max: 42 };
    return { min: 1, max: 100 };
  }

  function validateCurrentFields() {
    var heightInput = document.getElementById('bc-sg-height');
    if (heightInput && heightInput.value.trim() !== '') {
      parseHeightField(heightInput.value);
    }

    ['chest', 'waist', 'hip', 'leg'].forEach(function (field) {
      var input = document.getElementById('bc-sg-' + field);
      if (input && input.value.trim() !== '') {
        parseBodyField(field, input.value);
      }
    });
  }

  function hasAnyUsefulInput() {
    return Boolean(
      state.usualSize ||
      state.heightCm !== null ||
      state.chestIn !== null ||
      state.waistIn !== null ||
      state.hipIn !== null ||
      state.legIn !== null
    );
  }

  function canCalculate() {
    var generalError = document.getElementById('bc-sg-general-error');

    if (!hasAnyUsefulInput()) {
      if (generalError) generalError.textContent = 'Choose your usual size or enter at least one measurement.';
      return false;
    }

    if (generalError) generalError.textContent = '';

    var errorIds = [
      'bc-sg-height-error',
      'bc-sg-chest-error',
      'bc-sg-waist-error',
      'bc-sg-hip-error',
      'bc-sg-leg-error'
    ];

    for (var i = 0; i < errorIds.length; i++) {
      var error = document.getElementById(errorIds[i]);
      if (error && error.textContent) return false;
    }

    return true;
  }

  function updateCalculateButton() {
    var btn = document.getElementById('bc-sg-get-size');
    if (!btn) return;

    btn.disabled = !hasAnyUsefulInput();
  }

  function computeRecommendation(product) {
    if (product.union) {
      var order = ['2XS','XS','S','M','L','XL','XXL'];
      var usual = normaliseSize(state.usualSize);
      var exact = product.sizes.findIndex(function(s) { return normaliseSize(s) === usual; });
      var index = exact >= 0 ? exact : 0;
      var requested = order.indexOf(usual);
      state.outOfRange = (!usual && (product.type === 'top' ? state.chestIn === null : state.waistIn === null && state.hipIn === null)) || requested > order.indexOf(normaliseSize(product.sizes[product.sizes.length-1]));
      function consider(maxes, value) {
        if (value === null) return;
        if (value > maxes[maxes.length-1]) state.outOfRange = true;
        index = Math.max(index, getIndexFromMaxes(maxes, value, product));
      }
      if (product.type === 'top') consider(product.bodyChestMaxIn, state.chestIn);
      else { consider(product.bodyWaistMaxIn, state.waistIn); consider(isFemale() && product.womenHipMaxIn ? product.womenHipMaxIn : product.bodyHipMaxIn, state.hipIn); }
      return clamp(index, 0, product.sizes.length-1);
    }
    state.outOfRange = false;
    var index = state.usualSize && USUAL_TO_PRODUCT_INDEX[state.usualSize] !== undefined
      ? USUAL_TO_PRODUCT_INDEX[state.usualSize]
      : 1;

    index = clamp(index, 0, product.sizes.length - 1);

    if (product.baseAdj) {
      index = clamp(index + product.baseAdj, 0, product.sizes.length - 1);
    }

    if (product.type === 'top') {
      if (state.chestIn !== null) {
        index = Math.max(index, getIndexFromMaxes(product.bodyChestMaxIn || [], state.chestIn, product));
      }

      if (state.heightCm !== null && product.heightAdj) {
        index = clamp(index + product.heightAdj(state.heightCm), 0, product.sizes.length - 1);
      }
    }

    if (product.type === 'bottom') {
      var bottomIndexes = [];

      if (state.waistIn !== null) {
        bottomIndexes.push(getIndexFromMaxes(product.bodyWaistMaxIn || [], state.waistIn, product));
      }

      if (state.hipIn !== null) {
        var hipMaxes = isFemale() && product.womenHipMaxIn
          ? product.womenHipMaxIn
          : product.bodyHipMaxIn;

        bottomIndexes.push(getIndexFromMaxes(hipMaxes || [], state.hipIn, product));
      }

      if (bottomIndexes.length > 0) {
        index = Math.max.apply(null, [index].concat(bottomIndexes));
      }

      if (state.legIn !== null && product.legAdj) {
        index = clamp(index + product.legAdj(state.legIn), 0, product.sizes.length - 1);
      }
    }

    return clamp(index, 0, product.sizes.length - 1);
  }

  function getIndexFromMaxes(maxes, value, product) {
    if (!maxes || !maxes.length) return 1;

    for (var i = 0; i < maxes.length; i++) {
      if (value <= maxes[i]) return i;
    }

    return product.sizes.length - 1;
  }

  function showResult() {
    var product = state.product || PRODUCTS[DEFAULT_HANDLE];
    var recIndex = computeRecommendation(product);
    var recSize = product.sizes[recIndex];

    var recText = document.getElementById('bc-sg-rec-text');
    var note = document.getElementById('bc-sg-rec-note');
    var sizeUp = document.getElementById('bc-sg-rec-sizeup');
    var tableWrap = document.getElementById('bc-sg-table-wrap');

    if (recText) recText.textContent = state.outOfRange ? 'CHECK THE SIZE CHART' : 'SUGGESTED SIZE: ' + recSize;

    if (note) {
      note.textContent = buildRecommendationNote(product);
    }

    if (sizeUp) {
      var nextIndex = recIndex + 1;

      if (nextIndex < product.sizes.length) {
        sizeUp.textContent = product.fitTip + ' Want a looser fit? Try ' + product.sizes[nextIndex] + '.';
      } else {
        sizeUp.textContent = product.fitTip || '';
      }
    }

    if (tableWrap) {
      tableWrap.innerHTML = buildTable(product, recIndex);
    }

    updateRecommendedCart(recSize);
    goToStep(3);
  }


  var suggestedVariant = null;
  function updateRecommendedCart(size) {
    var button = document.getElementById('bc-sg-add');
    var status = document.getElementById('bc-sg-cart-status');
    var payload = document.getElementById('bc-sg-product-data');
    if (!button || !payload) return;
    var data = JSON.parse(payload.textContent);
    var select = document.querySelector('[data-u-variant]');
    var current = data.variants.find(function(v){return String(v.id) === (select && select.value);}) || data.variants.find(function(v){return v.id === data.selected;}) || data.variants[0];
    var sizeIndex = data.options.findIndex(function(o){return /size/i.test(o);});
    suggestedVariant = data.variants.find(function(v){
      return normaliseSize(v.options[sizeIndex]) === normaliseSize(size) && v.options.every(function(option,i){return i === sizeIndex || option === current.options[i];});
    });
    button.hidden = false;
    button.disabled = state.outOfRange || !suggestedVariant || !suggestedVariant.available;
    button.textContent = state.outOfRange ? 'Compare measurements before choosing' : !suggestedVariant || !suggestedVariant.available ? size + ' — currently unavailable' : 'Add recommended size ' + size + ' to bag';
    status.textContent = suggestedVariant && !state.outOfRange ? data.title + ' · ' + suggestedVariant.title : '';
    if (!button.disabled && select) {select.value = suggestedVariant.id; select.dispatchEvent(new Event('change',{bubbles:true}));}
  }
  async function addRecommendedToCart() {
    var button = document.getElementById('bc-sg-add');
    var status = document.getElementById('bc-sg-cart-status');
    if (button.disabled || !suggestedVariant) return;
    button.disabled = true;
    var label = button.textContent;
    button.textContent = 'Adding to bag…';
    try {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var response = await fetch(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:suggestedVariant.id,quantity:1}]})});
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This size could not be added. Please try again.');
      button.textContent = 'Added to bag';
      status.textContent = 'Added: ' + suggestedVariant.title + '. ';
      var link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'View bag and checkout'; status.appendChild(link);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch(error) { status.textContent = error.message; button.disabled = false; button.textContent = label; }
  }

  function buildRecommendationNote(product) {
    if (product.union && state.outOfRange) return 'Your inputs fall outside the sizes we can confidently suggest for this product. Compare the measurements below before choosing a size.';
    var note = product.note + ' This is a guide only — compare the garment measurements with something you already own for the best fit.';

    if (product.type === 'bottom' && isFemale() && state.hipIn === null) {
      note += ' For women’s bottoms, adding hip measurement will make this more accurate.';
    }

    if (product.type === 'bottom' && state.waistIn === null && state.hipIn === null && state.usualSize) {
      note += ' This result is mainly based on your usual size.';
    }

    if (product.type === 'top' && state.chestIn === null && state.usualSize) {
      note += product.union ? ' This result is based on your usual size.' : ' This result is mainly based on your usual size and height if entered.';
    }

    if (product.type === 'top' && state.heightCm !== null && state.heightCm >= 180 && (product.name === 'Boxy Oversized T-Shirt' || product.name === 'Zip-Through Boxy Fleece Hoodie')) {
      note += ' Because this item has a shorter body length, height has been weighted more strongly than width.';
    }

    if (product.union && (state.heightCm !== null || state.legIn !== null)) note += ' Height and inside leg do not change this estimate because the supplier does not provide body-height or inseam ranges. Check the garment length in the chart.';
    if (!product.union && product.type === 'bottom' && state.legIn !== null && state.legIn <= 32) {
      note += ' A 30–32 inside leg is treated as regular length, so it will not force a size up by itself.';
    }

    return note;
  }

  function buildTable(product, recIndex) {
    var useCm = state.bodyUnit === 'cm';
    var cols = useCm ? product.cmCols : product.inchCols;
    var data = useCm ? product.cmData : product.inchData;

    var html = '';

    html += '<div class="bc-sg__table-note">';
    html += product.tableNote ? escapeHtml(product.tableNote) : product.type === 'top'
      ? 'Garment measurements are taken flat. Pit to pit means armpit to armpit across the chest.'
      : 'Garment measurements are taken flat. Waist is relaxed, hip width is measured flat across the garment.';
    html += '</div>';

    html += '<table class="bc-sg__table">';
    html += '<thead><tr>';
    html += '<th class="bc-sg__th">SIZE</th>';

    cols.forEach(function (col) {
      html += '<th class="bc-sg__th">' + escapeHtml(col) + '</th>';
    });

    html += '</tr></thead><tbody>';

    product.sizes.forEach(function (size, index) {
      var isRecommended = index === recIndex;

      html += '<tr class="bc-sg__tr' + (isRecommended ? ' bc-sg__tr--rec' : '') + '">';
      html += '<td class="bc-sg__td bc-sg__td--size">' + escapeHtml(size) + '</td>';

      data[index].forEach(function (value) {
        html += '<td class="bc-sg__td">' + formatNumber(value) + '</td>';
      });

      html += '</tr>';
    });

    html += '</tbody></table>';

    return html;
  }

  function goToStep(step) {
    state.step = step;

    document.querySelectorAll('.bc-sg__step').forEach(function (el) {
      el.classList.add('bc-sg__step--hidden');
    });

    var targetId = step === 1 ? 'bc-sg-step-1' : step === 2 ? 'bc-sg-step-2' : 'bc-sg-result';
    var target = document.getElementById(targetId);

    if (target) target.classList.remove('bc-sg__step--hidden');

    var progress = document.getElementById('bc-sg-progress');
    var stepNum = document.getElementById('bc-sg-step-num');
    var backBtn = document.getElementById('bc-sg-back');

    if (progress) progress.style.display = step <= 2 ? '' : 'none';
    if (stepNum) stepNum.textContent = step <= 2 ? step : 2;
    if (backBtn) backBtn.style.display = step > 1 ? '' : 'none';

    updateFieldVisibility();
  }

  function openModal() {
    var modal = document.getElementById('bc-size-guide');
    if (!modal) return;

    detectProduct();
    var unavailable = document.getElementById('bc-sg-unavailable');
    if (!state.product) {
      if (!unavailable) {
        unavailable = document.createElement('p');
        unavailable.id = 'bc-sg-unavailable';
        unavailable.setAttribute('role', 'status');
        unavailable.style.cssText = 'font-size:13px;line-height:1.6;margin:12px 0';
        unavailable.innerHTML = 'A verified measurement chart is not yet available for this style. Please use the fit guidance below or <a href="/pages/contact">contact us for sizing help</a> before ordering.';
        var trigger = document.querySelector('[data-bc-open-size-guide]');
        if (trigger) trigger.insertAdjacentElement('afterend', unavailable);
      }
      unavailable.hidden = false;
      return;
    }
    if (unavailable) unavailable.hidden = true;
    updateFieldVisibility();
    updateCalculateButton();

    modal.removeAttribute('aria-hidden');
    modal.classList.add('bc-sg--open');
    if (window.BRWNScroll) { window.BRWNScroll.lock('bc-size-guide-open'); } else { document.body.classList.add('bc-size-guide-open'); document.body.style.overflow = 'hidden'; }
  }

  function closeModal() {
    var modal = document.getElementById('bc-size-guide');
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('bc-sg--open');
    if (window.BRWNScroll) { window.BRWNScroll.unlock('bc-size-guide-open'); } else { document.body.classList.remove('bc-size-guide-open'); document.body.style.overflow = ''; }
  }

  function resetAll() {
    var savedHandle = state.handle;
    var savedProduct = state.product;

    state = {
      step: 1,
      gender: null,
      usualSize: null,
      heightCm: null,
      heightUnit: 'ftin',
      bodyUnit: 'in',
      chestIn: null,
      waistIn: null,
      hipIn: null,
      legIn: null,
      handle: savedHandle,
      product: savedProduct
    };

    document.querySelectorAll('[data-sg-gender], [data-sg-size], [data-body-unit]').forEach(function (btn) {
      btn.classList.remove('bc-sg__btn--selected');
    });

    var defaultBodyUnit = document.querySelector('[data-body-unit="in"]');
    if (defaultBodyUnit) defaultBodyUnit.classList.add('bc-sg__btn--selected');

    ['height', 'chest', 'waist', 'hip', 'leg'].forEach(function (field) {
      var input = document.getElementById('bc-sg-' + field);
      if (input) input.value = '';
    });

    document.querySelectorAll('.bc-sg__field-error').forEach(function (el) {
      el.textContent = '';
    });

    setDefaultUnitButtons();
    updateFieldVisibility();
    updateCalculateButton();
    goToStep(1);
  }

  function clearBodyFields() {
    ['chest', 'waist', 'hip', 'leg'].forEach(function (field) {
      var input = document.getElementById('bc-sg-' + field);
      if (input) input.value = '';

      var error = document.getElementById('bc-sg-' + field + '-error');
      if (error) error.textContent = '';

      state[field + 'In'] = null;
    });
  }

  function handleEnterCalculate(event) {
    if (event.key !== 'Enter') return;

    var getBtn = document.getElementById('bc-sg-get-size');
    if (!getBtn || getBtn.disabled) return;

    event.preventDefault();
    validateCurrentFields();

    if (canCalculate()) {
      showResult();
    }
  }

  function activateBtns(buttons, activeButton) {
    buttons.forEach(function (btn) {
      btn.classList.remove('bc-sg__btn--selected');
    });

    activeButton.classList.add('bc-sg__btn--selected');
  }

  function clearError(id) {
    var el = document.getElementById(id);
    if (el) el.textContent = '';
  }

  function clamp(number, min, max) {
    return Math.min(Math.max(number, min), max);
  }

  function formatNumber(value) {
    if (Math.round(value) === value) return String(value);
    return String(value.toFixed(2)).replace(/\.00$/, '');
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();